<form class="standard-form">
  <h3>Sharing</h3>
  <mat-form-field width="100%">
    <mat-select [(value)]="selectedSubscription">
      <mat-option
        *ngFor="let subHeader of _availableSubscriptions"
        [value]="subHeader"
        >{{ subHeader.subscriptionName }} -
        {{ subHeader.organizationName }}</mat-option
      >
    </mat-select>
    <mat-label>Subscription</mat-label>
  </mat-form-field>
  <ng-container>
    <div class="row">
      <div class="col-sm-6 mainLabel">Group</div>
      <div class="col-sm-2 mainLabel" style="text-align: center">
        Not Shared
      </div>
      <div
        *ngIf="allowReadOnly"
        class="col-sm-2 mainLabel"
        style="text-align: center"
      >
        Read Only
      </div>
      <div
        *ngIf="allowModify"
        class="col-sm-2 mainLabel"
        style="text-align: center"
      >
        Allow Modify
      </div>
    </div>
    <div
      class="row"
      *ngFor="let group of selectedSubscription?.userSubscriptionGroups"
    >
      <div class="col-sm-6">
        <b>{{ group.groupName }}</b>
      </div>
      <div class="col-sm-2" style="text-align: center">
        <mat-checkbox
          [name]="group.subscriptionGroupId + '-0'"
          (change)="groupCheckChanged($event)"
          [checked]="groupIsSelected(0, group.subscriptionGroupId)"
        ></mat-checkbox>
      </div>
      <div *ngIf="allowReadOnly" class="col-sm-2" style="text-align: center">
        <mat-checkbox
          [name]="group.subscriptionGroupId + '-1'"
          (change)="groupCheckChanged($event)"
          [checked]="groupIsSelected(1, group.subscriptionGroupId)"
        ></mat-checkbox>
      </div>
      <div *ngIf="allowModify" class="col-sm-2" style="text-align: center">
        <mat-checkbox
          [name]="group.subscriptionGroupId + '-2'"
          (change)="groupCheckChanged($event)"
          [checked]="groupIsSelected(2, group.subscriptionGroupId)"
        ></mat-checkbox>
      </div>
    </div>
  </ng-container>
</form>
